<template>
  <v-card
    :width="$vuetify.breakpoint.smAndDown ? '100%' : '480px'"
    light
    class="rounded-md"
    style="height: 80vh; display: flex; flex-direction: column"
  >
    <v-card-title
      primary-title
      style="background-color: black; text-align: left"
      class="pa-6"
      color="white"
    >
      <span style="font-family: Inter; color: white" class="text-h5">
        <v-icon v-if="isAddMode" color="white" style="margin-top: -5px"
          >mdi-plus</v-icon
        >
        <v-icon v-else color="white" style="margin-top: -3px">mdi-cog</v-icon>
        {{ mode }} Node
      </span>
    </v-card-title>
    <v-form
      ref="editForm"
      v-model="valid"
      style="
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
      "
      @submit.prevent="callAddNode"
    >
      <v-col class="pa-6 overflow-y-auto" style="flex: 1 1 auto">
        <v-card-text class="pa-0" color="black">
          <span style="font-family: Inter; font-weight: 600">
            Node Name
          </span></v-card-text
        >
        <v-text-field
          ref="nameInput"
          v-model="name"
          outlined
          dense
          light
          color="black"
          class="mb-0"
          type="text"
          placeholder="Node 1"
          :rules="[rules.notEmpty]"
        >
        </v-text-field>
        <v-card-text class="pa-0" color="black">
          <span style="font-family: Inter; font-weight: 600">
            Node Type
          </span></v-card-text
        >
        <v-select
          v-model="type"
          :items="nodeTypes"
          single-line
          outlined
          label="Node Type"
          dense
          color="black"
          :rules="[rules.notZero]"
          @change="updateSortOrder"
        ></v-select>
        <v-card-text class="pa-0" color="black">
          <span style="font-family: Inter; font-weight: 600">
            IP Address
          </span></v-card-text
        >
        <v-text-field
          v-model="ip"
          outlined
          dense
          light
          color="black"
          class="mb-0"
          type="text"
          placeholder="127.0.0.1"
          :rules="[rules.notEmpty]"
        >
        </v-text-field>
        <v-row>
          <v-col cols="6">
            <v-card-text class="pa-0" color="black">
              <span style="font-family: Inter; font-weight: 600">
                Port
              </span></v-card-text
            >
            <v-text-field
              v-model="port"
              outlined
              dense
              light
              color="black"
              class="mb-0"
              type="text"
              placeholder="3000"
              :rules="[rules.nonNegativeInteger]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-card-text class="pa-0" color="black">
              <span style="font-family: Inter; font-weight: 600">
                Route (Optional)
              </span>
            </v-card-text>
            <v-text-field
              v-model="route"
              outlined
              dense
              light
              color="black"
              class="mb-0"
              type="text"
              placeholder="/path-to-node"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-card-text class="pa-0" color="black">
          <span style="font-family: Inter; font-weight: 600">
            Sort Order
          </span></v-card-text
        >
        <v-text-field
          v-model.number="sort_order"
          outlined
          dense
          light
          color="black"
          class="mb-0"
          type="number"
          :min="0"
          :rules="[rules.nonNegativeInteger, validateSortOrder]"
        ></v-text-field>
        <v-checkbox v-model="ssl" color="black" class="mt-0">
          <template #label>
            <v-card-text class="pa-0" color="black">
              <span style="font-family: Inter; font-weight: 600; color: black">
                Use SSL for connections
              </span></v-card-text
            >
          </template>
        </v-checkbox>
        <v-card-text class="pa-0" color="black">
          <span style="font-family: Inter; font-weight: 600">
            Ingestor
          </span></v-card-text
        >
        <v-select
          v-model="ingestor_name"
          :items="ingestors"
          single-line
          outlined
          label="Ingestor"
          dense
          color="black"
        ></v-select>
      </v-col>
      <div class="pa-6" style="text-align: right">
        <v-btn
          large
          depressed
          text
          class="ml-4 rounded-md no-active-btn"
          @click="$emit('cancel')"
        >
          <span
            style="
              font-family: Inter;
              text-transform: none;
              font-weight: 600;
              margin-top: -3px;
            "
            >Cancel</span
          >
        </v-btn>
        <v-btn
          v-if="isEditMode"
          depressed
          large
          color="red"
          class="rounded-md ml-4 white--text pr-3"
          @click="callDeleteNode"
        >
          <span
            style="
              font-family: Inter;
              text-transform: none;
              font-weight: 600;
              margin-top: -3px;
            "
            >Delete</span
          >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn
          depressed
          large
          color="black"
          class="rounded-md ml-4 white--text pr-3"
          type="submit"
          :disabled="isLoading"
          @click="callAddNode"
        >
          <template v-if="isLoading">
            <v-progress-circular
              indeterminate
              color="white"
              size="24"
              width="3"
              class="mr-2"
            ></v-progress-circular>
          </template>
          <template v-else>
            <span
              style="
                font-family: Inter;
                text-transform: none;
                font-weight: 600;
                margin-top: -3px;
              "
              >{{ okButtonCaption }}</span
            >
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import axios from 'axios';

import { EditDialogModeEnum } from '../../../enums/editDialogModeEnum';
import {
  nodeTypeDict,
  nodeTypeDictReversed,
} from '../../../services/nodeTypeService';
import errorUtility from '../../../services/errorUtility';
import {
  nonNegativeInteger,
  notEmpty,
  notZero,
} from '../../../services/rulesService';

import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    chainId: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: EditDialogModeEnum.Edit,
    },
    node: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      id: null,
      name: '',
      ip: '',
      port: '',
      type: 'Nodeos Follower',
      original_type: null,
      ssl: false,
      sort_order: 0,
      ingestor_id: '',
      ingestor_name: '(None)',
      rules: {
        nonNegativeInteger,
        notEmpty,
        notZero,
      },
      valid: true,
      isLoading: false,
      original_sort_order: null,
      route: '',
    };
  },
  computed: {
    ...mapGetters(['getNextSortOrder', 'checkValidSortOrder']),
    nodeTypes() {
      return Object.keys(nodeTypeDict);
    },
    okButtonCaption() {
      return this.mode == EditDialogModeEnum.Add ? 'Create' : 'Save';
    },
    ingestors() {
      return this.$store.state.ingestors.ingestors
        .map((ingestor) => ingestor.name)
        .concat(['(None)']);
    },
    isAddMode() {
      return this.mode == EditDialogModeEnum.Add;
    },
    isEditMode() {
      return this.mode == EditDialogModeEnum.Edit;
    },
    chain() {
      return this.chainId
        ? this.$store.state.chain.chains.filter(
            (chain) => chain.id === this.chainId
          )[0]
        : null;
    },
  },
  mounted() {
    this.id = this.node.id;
    this.sort_order = this.node.sort_order;

    // Focus on the name input field
    this.$nextTick(() => {
      this.$refs.nameInput.focus();
    });

    if (this.mode == EditDialogModeEnum.Edit) {
      this.setNode(this.node);
      this.original_type = this.node.type;
    } else {
      this.setDefaultIngestor();
      this.type = 'Nodeos Follower';
    }
    this.updateSortOrder();
  },
  methods: {
    ...mapActions(['initialiseTables']),
    setNode(node) {
      this.id = node.id;
      this.name = node.name;
      this.ip = node.network_address;
      this.port = node.port;
      this.ssl = node.ssl;
      this.type = nodeTypeDictReversed[node.type];
      this.sort_order = node.sort_order;
      this.ingestor_id = node.ingestor_id;
      this.ingestor_name = node.ingestor_id
        ? this.$store.state.ingestors.ingestors.find(
            (ingestor) => ingestor.id == node.ingestor_id
          )?.name || '(None)'
        : '(None)';
      this.original_sort_order = node.sort_order;
      this.route = node.route || '';
    },
    setDefaultIngestor() {
      const firstIngestor = this.$store.state.ingestors.ingestors[0];
      this.ingestor_name = firstIngestor ? firstIngestor.name : '(None)';
      this.ingestor_id = firstIngestor ? firstIngestor.id : null;
    },
    async callAddNode() {
      console.log('callAddNode: starting');
      this.isLoading = true;
      try {
        if (!this.$refs.editForm.validate()) {
          this.isLoading = false;
          return;
        }

        let ingestor_id = null;
        if (this.ingestor_name != '(None)') {
          ingestor_id = this.$store.state.ingestors.ingestors.filter(
            (ingestor) => ingestor.name == this.ingestor_name
          )[0].id;
        }

        let payload = {
          id: this.id,
          name: this.name,
          network_address: this.ip,
          port: this.port,
          route: this.route || '',
          ssl: !!this.ssl,
          type: nodeTypeDict[this.type],
          chain_id: this.chainId,
          active: true,
          sort_order: parseInt(this.sort_order),
          ingestor_id: ingestor_id,
        };

        // Set up the watcher before making the API call
        const nodeAddedPromise = new Promise((resolve) => {
          const unwatch = this.$store.watch(
            (state) => state.chain.chains,
            (newChains) => {
              const newNodeExists = newChains.some((chain) =>
                chain.nodes.some((node) => node.id === this.id)
              );
              if (newNodeExists) {
                unwatch();
                resolve();
              }
            }
          );

          // Set a timeout to resolve the promise if the store update doesn't happen
          setTimeout(() => {
            unwatch();
            console.warn('Store update timed out, proceeding anyway');
            resolve();
          }, 6000);
        });

        // Make the API call
        await axios.post('/api/v1/node/', payload);

        // Wait for the store to be updated or for the timeout
        await nodeAddedPromise;

        if (this.isAddMode || this.original_type != nodeTypeDict[this.type]) {
          await this.applyDefaults();
        }

        console.log('callAddNode: finishing');
        this.$emit('confirm');
        let nodeUrl = `/node/${this.chainId.toString()}/${this.id}`;
        if (this.$route.path !== nodeUrl) {
          this.$router.push(nodeUrl);
        }
      } catch (error) {
        console.error('Error in callAddNode:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async applyDefaults() {
      console.log('applyDefaults: starting');

      if (!this.chain) {
        console.error('Chain not found in store');
        return;
      }

      let node_created = this.chain.nodes.find((node) => node.id === this.id);

      if (!node_created) {
        console.error('Node not found in chain.nodes after creation');
        return;
      }

      let defaults = this.getDefaultSettings(node_created.type);
      await this.saveMetricsConfiguration(node_created, defaults, []);

      // Polling approach to check for node updates
      const nodeUpdatedPromise = new Promise((resolve) => {
        const interval = setInterval(() => {
          const updatedChain = this.$store.state.chain.chains.find(
            (chain) => chain.id === this.chainId
          );
          const updatedNode = updatedChain?.nodes.find(
            (node) => node.id === this.id
          );

          if (
            updatedNode &&
            updatedNode.alerts &&
            updatedNode.alerts.length > 0
          ) {
            clearInterval(interval);
            resolve(updatedNode);
          }
        }, 1000); // Check every second

        // Set a timeout to stop polling after a certain period
        setTimeout(() => {
          clearInterval(interval);
          console.warn('Polling timed out, proceeding anyway');
          resolve(null);
        }, 6000);
      });

      let node_updated = await nodeUpdatedPromise;
      let connect_latency_alerts = [];
      node_updated.alerts.forEach((alert) => {
        let moduleName = alert.metric.split('/')[0];
        let metricName = alert.metric.split('/')[1];
        if (defaults[moduleName]) {
          let metric = defaults[moduleName].metrics[metricName];
          if (
            metric &&
            !metric.information.Can_Manually_Enable &&
            metric.information.Url_Paths.includes(alert.url)
          ) {
            connect_latency_alerts.push({
              alert: {
                id: alert.id,
                condition: metric.information.Alerting_Default.includes(
                  node_updated.type
                ),
              },
            });
          }
        }
      });
      this.saveMetricsConfiguration(
        node_updated,
        defaults,
        connect_latency_alerts
      );
      console.log('applyDefaults: finishing');
    },
    async callDeleteNode() {
      if (confirm('Are you sure you want to delete this node?') == false) {
        return;
      }
      try {
        await axios.delete(`/api/v1/node/${this.id}`);
        this.initialiseTables();
        let chainUrl = `/chain/${this.chainId.toString()}`;
        this.$router.push(chainUrl);
        this.$emit('confirm');
      } catch (e) {
        errorUtility.handleServerError(e);
      }
    },
    updateSortOrder() {
      if (this.isAddMode) {
        this.sort_order = this.getNextSortOrder(
          this.chainId,
          nodeTypeDict[this.type]
        );
      }
    },
    validateSortOrder() {
      if (
        this.mode === EditDialogModeEnum.Edit &&
        this.sort_order === this.original_sort_order
      ) {
        return true;
      }

      const isValid = this.checkValidSortOrder(
        this.chainId,
        nodeTypeDict[this.type],
        this.sort_order
      );
      return isValid || 'This sort order is already in use';
    },
  },
};
</script>

<style></style>
